import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path opacity=".25" d="M18.5 16.5V7.5M16.5 5.5H7.5M5.5 7.5V16.5" vectorEffect="non-scaling-stroke" />
		<Path d="M7.5 18.5H16.5" vectorEffect="non-scaling-stroke" />
	</SVG>
);
